import styled from 'styled-components';
import { key } from 'styled-theme';

export default styled.div`
  width: 100%;
  display: block;
  margin: 30px 0;
  padding: 25px 20px 25px 15px;
  background: ${key('colors.white')};
  border-radius: ${key('sizes.borderRadius')};

  img {
    display: block;
    width: 100%;
  }

  ul {
    margin: 28px 0 0 0;
    padding: 0 0 0 7px;
    list-style: none;

    li {
      display: flex;
      flex-flow: row wrap;
      align-items: center;
      justify-content: flex-start;
      margin-top: 6px;
      color: ${key('colors.black.light[400]')};

      span {
        display: block;
        flex: 0 0 20px;
        height: 4px;
        margin-right: 9px;
        border-radius: 2px;

        &.red {
          background: ${key('colors.red.default')};
        }

        &.gray {
          background: ${key('colors.black.light[400]')};
        }
      }
    }
  }
`;
